<template>
    <div class="col-12 mx-auto">
        <div>
            <div class="loader" v-show="working"></div>
            <div v-show="!working" class="card">
                <div class="card-header" v-if="showNewButton || showSettingsBtn">
                    <button type="button" class="btn btn-primary btn"
                            v-if="showNewButton && claims.rankingCriteriaRegister.create"
                            @click="createBtnClick">
                        {{$t('buttons.create.btnText')}}
                    </button>

                    <span v-if="showformsGridSettings">
                        <i class="fas fa-cogs pointer fa-2x float-right text-primary"
                           @click.stop="changeGridSettings"
                           data-toggle="tooltip"
                           :title="settingsTooltipText"></i>
                    </span>

                    <div v-if="showformsGridSettings">
                        <GridUserSettings ref="formsGridSettings"
                                          :visible="showformsGridSettingsForm"
                                          :grid="$refs['rankingCriteriaGrid']"
                                          :componentName="componentName">
                        </GridUserSettings>
                    </div>
                </div>

                <div class="btn-toolbar justify-content-between mb-0 mt-2" role="toolbar">
                    <div class="col-sm-12 col-md-6">

                    </div>
                    <div class="input-group">
                        <input v-model="searchQuery" v-on:keyup.enter.stop="massSearch" v-on:keyup.esc.stop="clearFilters" type="text" class="form-control" aria-label="Mass search input" aria-describedby="massSearch">
                        <button class="btn btn-secondary" @click.stop="massSearch">
                            <i class="fas fa-search"></i>
                            {{ $t('buttons.search.btnText') }}
                        </button>
                        <button class="btn btn-secondary"
                                @click.stop="clearFilters">
                            <i class="fas fa-times"></i>
                            {{ $t('buttons.clearFilters.btnText') }}
                        </button>
                    </div>
                </div>

                <div class="card-body">
                    <kendo-datasource ref="datasource1"
                                      :transport="transportSettings"
                                      :schema-model-id="'id'"
                                      :schema-model-fields="schemaModelFields"
                                      :schema-total="'total'"
                                      :schema-data="'data'"
                                      :page-size='gridOptions.pageable.size'
                                      :server-paging="true"
                                      :server-sorting="true"
                                      :server-filtering="true"
                                      :error="dataSourceError"
                                      :requestEnd="datasorceRequestEnd">
                    </kendo-datasource>

                    <kendo-grid ref="rankingCriteriaGrid"
                                id="rankingCriteriaGrid"
                                :data-source-ref="'datasource1'"
                                :pageable="gridOptions.pageable"
                                :navigatable="gridOptions.navigatable"
                                :editable="gridOptions.editable"
                                :filterable="gridOptions.filterable"
                                :reorderable="gridOptions.reorderable"
                                :resizable="gridOptions.resizable"
                                :groupable="gridOptions.groupable"
                                :allow-copy="gridOptions.allowCopy"
                                :column-menu="gridOptions.columnMenu"
                                :sortable-mode="gridOptions.sortable.mode"
                                :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                                :sortable-show-indexes="gridOptions.sortable.showIndexes"
                                :selectable="gridOptions.selectable"
                                :scrollable="gridOptions.scrollable"
                                :toolbar="toolbar"
                                :excel="gridOptions.excel"
                                :data-bound="dataBound"
                                name="rankingCriteriaGrid">
                        <kendo-grid-column v-if="showBtns"
                                           :title="$t('actions')"
                                           field="btnsColumn"
                                            :reorderable="false"
                                            :sortable="false"
                                            :filterable="false"
                                           :width="150"
                                           :template="btnsTemplate"
                                           :lockable="true"
                                           :locked="false">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'id'"
                                           :filterable="false"
                                           :title="$t('rankingCriteria.gridHeaders.id')"
                                           :width="100"
                                           :hidden="true"
                                           :lockable="true"
                                           :locked="false">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'name'"
                                           :title="$t('rankingCriteria.gridHeaders.name')"
                                           :width="200"
                                           :lockable="true"
                                           :locked="false"
                                           :hidden="isEnVersion">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'nameEn'"
                                           :title="$t('rankingCriteria.gridHeaders.name')"
                                           :width="200"
                                           :lockable="true"
                                           :locked="false"
                                           :hidden="!isEnVersion">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'other1'"
                                           :title="$t('rankingCriteria.gridHeaders.other1')"
                                           :width="150"
                                           :lockable="true"
                                           :locked="false">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'other2'"
                                           :title="$t('rankingCriteria.gridHeaders.other2')"
                                           :width="150"
                                           :lockable="true"
                                           :locked="false">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'deactivated'"
                                           :title="$t('rankingCriteria.gridHeaders.deactivated')"
                                           :width="100"
                                           :lockable="true"
                                           :locked="false"
                                           :template="deactivatedCellTemplate">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'eventFormsStr'"
                                           :hidden="isEnVersion"
                                           :width="150"
                                           :title="$t('rankingCriteria.gridHeaders.eventForm')">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'eventFormsStrEn'"
                                           :width="150"
                                           :hidden="!isEnVersion"
                                           :title="$t('participationRelationType.gridHeaders.eventForm')">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'creatorUsername'"
                                           :title="$t('rankingCriteria.gridHeaders.creatorUsername')"
                                           :width="150"
                                           :lockable="true"
                                           :locked="false">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'createdAtUtc'"
                                           :title="$t('rankingCriteria.gridHeaders.createdAtUtc')"
                                           :width="150"
                                           :format="customDateTimeFormat"
                                           :lockable="true"
                                           :locked="false">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'updaterUsername'"
                                           :title="$t('rankingCriteria.gridHeaders.updaterUsername')"
                                           :width="150"
                                           :lockable="true"
                                           :locked="false">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'updatedAtUtc'"
                                           :title="$t('rankingCriteria.gridHeaders.updatedAtUtc')"
                                           :width="150"
                                           :format="customDateTimeFormat"
                                           :lockable="true"
                                           :locked="false">
                        </kendo-grid-column>
                    </kendo-grid>
                </div>
            </div>
        </div>

        <RankingCriteriaCreateModal :show="showCreate" @onClose="onCreateClose" @onSave="onCreate"></RankingCriteriaCreateModal>
        <RankingCriteriaEditModal v-model="model" :show="showEdit" @onClose="onEditClose" @onSave="onEdit"></RankingCriteriaEditModal>
        <RankingCriteriaDetailsModal v-model="model" :show="showDetails" @onClose="onDetailsClose"></RankingCriteriaDetailsModal>
        <JsonFormatter
            v-model="dataReferences"
            :show.sync="showDataReferences"
            :titleKey="'buttons.links.tooltipText'"
            @onClose="onDataReferencesClose"
        >
        </JsonFormatter>
    </div>

</template>

<script src="https://kendo.cdn.telerik.com/2019.2.619/js/pako_deflate.min.js"></script>

<script>
    import Vue from 'vue';
    import JSZip from 'jszip'
    import GridUserSettings from '@/components/grid/GridSettingsWrapper';
    import BtnsTemplate from "@/components/grid/StandardBtnsTemplate";
    import RankingCriteriaEditModal from './edit.modal'
    import RankingCriteriaDetailsModal from './details.modal'
    import RankingCriteriaCreateModal from './create.modal'
    import service from '@/services/rankingCriteria.service';
    import { mapGetters } from 'vuex';
    import dataReferencesService from "@/services/dataReferences.service";
    import JsonFormatter from "@/components/common/json.formatter.modal.vue";

    export default {
        name: 'ranking-criteria-grid',
        components: {
            GridUserSettings,
            RankingCriteriaEditModal,
            RankingCriteriaCreateModal,
            RankingCriteriaDetailsModal,
            JsonFormatter
        },
        created: function () {
            window.JSZip = JSZip
        },
        props: {
            showNewButton: {
                default: true,
                type: Boolean
            },
            showSettingsBtn: {
                default: true,
                type: Boolean
            },
            showBtns: {
                default: true,
                type: Boolean
            },
            returnUrl: {
                type: String
            },
            componentName: {
                default: 'RankingCriteriaGrid',
                type: String
            }
        },
        data() {
            return {
                showformsGridSettingsForm: false,
                showformsGridSettings: false,
                settingsTooltipText: this.$t('buttons.settings.tooltipText'),
                titleKey: 'registers.forms.title',
                searchQuery: '',
                schemaModelFields: {
                    id: { name: 'id', type: 'number', nullable: false },
                    name: { name: 'name', type: 'string', nullable: false },
                    nameEn: { name: 'nameEn', type: 'string', nullable: true },
                    other1: { name: 'other1', type: 'string', nullable: true },
                    other2: { name: 'other2', type: 'string', nullable: true },
                    deactivated: { name: 'deactivated', type: 'boolean', nullable: true },
                    createdAtUtc: { name: 'createdAtUtc', type: 'date', nullable: true },
                    creatorUsername: { name: 'creatorUsername', type: 'string', nullable: true },
                    updatedAtUtc: { name: 'updatedAtUtc', type: 'date', nullable: true },
                    updaterUsername: { name: 'updaterUsername', type: 'string', nullable: true },
                    eventFormsStr: { name: 'eventFormsStr', type: 'string', nullable: true },
                    eventFormsStrEn: { name: 'eventFormsStrEn', type: 'string', nullable: true },
                },
                transportSettings: {
                    read: {
                        url: this.$store.getters.baseUrl + '/api/rankingCriteria/list',
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                },
                gridOptions: {
                    ...this.$store.getters.gridOptions,
                    excel: {
                        fileName: 'RankingCriteria.xlsx',
                        allPages: false,
                        filterable: true,
                        collapsible: true
                    }
                },
                working: false,
                model: null,
                showEdit: false,
                showCreate: false,
                showDetails: false,
                dataReferences: "",
                showDataReferences: false,
            }
        },
        methods: {
            dataBound(e) {
                if (e.sender.options.dataSourceRef == 'datasource1'
                    && this.showSettingsBtn
                    && !this.showformsGridSettings) {
                    this.showformsGridSettings = true;
                }

                var items = e.sender.items();
                items.each(function (idx, item) {
                    let dataItem = e.sender.dataItem(item);
                    if (dataItem.deactivated === false) {
                        $(item).addClass('left-border-green');
                    } else {
                        $(item).addClass('left-border-danger');
                    }
                });
            },
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                });
            },
            datasorceRequestEnd(e) {
            },
            parameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {
                    return kendo.stringify(options);
                }
            },
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            changeGridSettings() {
                this.showformsGridSettingsForm = !this.showformsGridSettingsForm;
            },
            deactivatedCellTemplate: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.deactivated ? 'badge-danger' : 'badge-success') + '">' + kendo.htmlEncode(dataItem.deactivated ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },
            createBtnClick() {
                if (!this.claims.rankingCriteriaRegister.create) {
                    return this.$router.push(`/unauthorized`);
                }

                this.showCreate = true;
            },
            editBtnClick(args) {
                if (!this.claims.rankingCriteriaRegister.update) {
                    return this.$router.push(`/unauthorized`);
                }

                this.showModal(args.id, false);
            },
            detailsBtnClick: function (args) {
                if (!this.claims.rankingCriteriaRegister.read) {
                    return this.$router.push(`/unauthorized`);
                }

                this.showModal(args.id, true);
            },
            deactivateBtnClick(args) {
                if (!this.claims.rankingCriteriaRegister.delete) {
                    return this.$router.push(`/unauthorized`);
                }

                if (args.deactivated) {
                    this.$vs.notify({
                        title: this.$t('buttons.deactivate.action'),
                        text: this.$t('buttons.deactivate.already'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration,
                    })

                    return;
                }

                this.$http.delete('/api/rankingCriteria/deactivate',
                    { params: { id: args.id } }
                ).then((response) => {
                    this.refresh();

                    this.$vs.notify({
                        title: this.$t('buttons.deactivate.action'),
                        text: this.$helpers.responseMessage(response),
                        color: 'success',
                        time: this.$store.getters.notificationDuration,
                    })
                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                }).then();

            },
            activateBtnClick(args) {
                if (!this.claims.rankingCriteriaRegister.delete) {
                    this.$router.push(`/unauthorized`);
                    return;
                }

                if (!args.deactivated) {
                    this.$vs.notify({
                        title: this.$t('buttons.activate.action'),
                        text: this.$t('buttons.activate.already'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration,
                    })

                    return;
                }

                this.$http.delete('/api/rankingCriteria/activate',
                    { params: { id: args.id } }
                ).then((response) => {
                    this.refresh();

                    this.$vs.notify({
                        title: this.$t('buttons.activate.action'),
                        text: response.message ? response.message : (response.request.statusText ? response.request.statusText : response.message),
                        color: 'success',
                        time: this.$store.getters.notificationDuration,
                    })
                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                }).then();
            },
            refresh() {
                const grid = this.$refs.rankingCriteriaGrid.kendoWidget();
                if (grid) {
                    grid.dataSource.read();
                }
            },
            clearFilters() {
                this.searchQuery = '';
                const grid = this.$refs.rankingCriteriaGrid.kendoWidget();
                if (grid) {
                    grid.dataSource.sort({});
                    grid.dataSource.page(1);
                    grid.dataSource.aggregate([]);
                    grid.dataSource.filter({});
                }
            },
            massSearch() {
                if (!this.searchQuery) {
                    this.$vs.notify({
                        title: this.$t('buttons.search.btnText'),
                        text: this.$t('emptySearchFilter'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration
                    })

                    return;
                }

                let grid = this.$refs.rankingCriteriaGrid.kendoWidget();
                if (grid) {
                    let filter = this.$helpers.getMassFilterForGrid(grid, this.searchQuery);
                    if (filter) {
                        grid.dataSource.filter(filter);
                    }
                }
            },
            btnsTemplate: function (e) {
                return {
                    template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                    templateArgs: {
                        ...e,
                        parentComponent: this.$refs.rankingCriteriaGrid,
                        btns: [
                            {
                                name: "edit",
                                text: this.$t('buttons.edit.btnText'),
                                tooltip: this.$t('buttons.edit.btnText'),
                                class: 'btn btn-primary',
                                icon: "fas fa-edit",
                                show: this.claims.rankingCriteriaRegister.update,
                                clickHandler: this.editBtnClick
                            },
                            {
                                name: "details",
                                text: this.$t('buttons.details.btnText'),
                                tooltip: this.$t('buttons.details.btnText'),
                                class: 'btn btn-primary',
                                icon: "fas fa-info-circle",
                                show: this.claims.rankingCriteriaRegister.read,
                                clickHandler: this.detailsBtnClick
                            },
                            {
                                name: "activate",
                                text: this.$t('buttons.activate.btnText'),
                                tooltip: this.$t('buttons.activate.btnText'),
                                class: 'btn btn-danger',
                                icon: "fas fa-lock-open",
                                show: e.deactivated && this.claims.rankingCriteriaRegister.delete,
                                clickHandler: this.activateBtnClick
                            },
                            {
                                name: "deactivate",
                                text: this.$t('buttons.deactivate.btnText'),
                                tooltip: this.$t('buttons.deactivate.btnText'),
                                class: 'btn btn-danger',
                                icon: "fas fa-lock",
                                show: !e.deactivated && this.claims.rankingCriteriaRegister.delete,
                                clickHandler: this.deactivateBtnClick
                            },
                            {
                                name: "checkLinks",
                                text: "",
                                tooltip: this.$t("buttons.links.btnText"),
                                class: "btn btn-info",
                                icon: "fa fa-link",
                                show: this.claims.dataReferences.read,
                                clickHandler: this.dataReferencesBtnClick,
                            },
                        ]
                    }
                };
            },
            showModal(id, details) {
                service
                    .getById(id)
                    .then(response => {
                        let model = response.data;
                        if (model) {
                            this.model = model;
                            if (details) {
                                this.showDetails = true;
                            } else {
                                this.showEdit = true;
                            }

                        } else {
                            this.model = null;
                            if (details) {
                                this.showDetails = false;
                            } else {
                                this.showEdit = false;
                            }
                        }
                    })
                    .catch(error => {
                        this.model = null;
                        if (details) {
                            this.showDetails = false;
                        } else {
                            this.showEdit = false;
                        }

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            onCreate(item) {
                this.showCreate = false;
                this.model = null;
                this.refresh();
            },
            onEdit(item) {
                this.showEdit = false;
                this.model = null;
                this.refresh();
            },
            onCreateClose() {
                this.showCreate = false;
                this.model = null;
            },
            onEditClose() {
                this.showEdit = false;
                this.model = null;
            },
            onDetailsClose() {
                this.showDetails = false;
                this.model = null;
            },
            dataReferencesBtnClick(args) {
                if (!this.claims.dataReferences.read) {
                    return this.$router.push(`/unauthorized`);
                }

                return this.getDataReferences(args.id);
            },
            getDataReferences(id) {
                dataReferencesService
                    .checkReferences("Registers", "RankingCriteria", id, this.dataReferencesListCount, true)
                    .then((response) => {
                        if (response.data) {
                            this.dataReferences = response.data;
                        }

                        this.showDataReferences = true;
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            },
            onDataReferencesClose() {
                this.dataReferences = "";
                this.showDataReferences = false;
            },
        },
        computed: {
            ...mapGetters(['dateTimeFormat', 'isEnVersion', 'claims', 'dataReferencesListCount']),
            customDateTimeFormat() {
                return `{0: ${this.dateTimeFormat}}`;
            },
            token: function () {
                return this.$store.getters.authToken;
            },
            toolbar: function () {
                return [{ name: 'excel', text: this.$t('buttons.excelExport.tooltipText') }]
            }
        }
    }
</script>


<style>
    /*
        Use the DejaVu Sans font for display and embedding in the PDF file.
        The standard PDF fonts have no support for Unicode characters.
    */
    .k-pdf-export .k-grid {
        font-family: "DejaVu Sans", "Arial", sans-serif;
    }

    .k-pdf-export .k-filterable .k-grid-filter {
        display: none;
    }

    .k-pdf-export .k-with-icon .k-header-column-menu {
        display: none;
    }

    .k-grid .k-grid-header .k-header .k-link {
        height: auto;
    }

    .k-grid .k-grid-header .k-header {
        white-space: normal;
    }

    .k-grid-edit, .k-grid-details, .k-grid-delete, .k-grid-pdf, .k-grid-excel {
        padding: 0;
        margin-bottom: 2px;
    }
</style>

<style lang="scss">
    tr.left-border-danger {
        &:hover

    {
        color: rgba(255, 0, 0, 0.7) !important;
    }

    td:first-child {
        border-left: 3px solid rgba(255, 0, 0, 0.5) !important;
    }

    }

    tr.left-border-blue {
        &:hover

    {
        color: #3498db !important;
    }

    td:first-child {
        border-left: 3px solid #3498db !important;
    }

    }

    tr.left-border-green {
        &:hover

    {
        color: #4caf50 !important;
    }

    td:first-child {
        border-left: 3px solid #4caf50 !important;
    }
    }
</style>
